import { render, staticRenderFns } from "./Swiper-black-vip.vue?vue&type=template&id=c6d4f132&"
import script from "./Swiper-black-vip.vue?vue&type=script&lang=js&"
export * from "./Swiper-black-vip.vue?vue&type=script&lang=js&"
import style0 from "./Swiper-black-vip.vue?vue&type=style&index=0&id=c6d4f132&prod&lang=less&less=scoped&"
import style1 from "./Swiper-black-vip.vue?vue&type=style&index=1&id=c6d4f132&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports